import React, { Component } from "react";
import $ from "jquery";
import _ from "lodash";
import axios from "./auth-header";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { MDBInput } from "mdbreact";
import TextField from "@material-ui/core/TextField";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import AuthService from "../Auth/AuthService";
import Service from "../Admin/Users/EditUser/EditUserService";
import PermissionFeature from "../Permissions/PermissionFeature";

const filter = createFilterOptions();

class AddressModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Form fields
      id: null,
      address1: "",
      address2: "",
      address3: "",
      city: "",
      state: "",
      zipcode: "",
      addresstypeid: 1,
      county: "",
      isInternational: false,
      country: "",
      notes: "",

      // UI states
      validateUSPS: true,
      manualEntry: false,
      textareaActive: false,
      isLoading: false,

      // Smarty states - Separate search field
      smartySearchQuery: "",
      smartySuggestions: [],
      showSmartySuggestions: false,
      isLoadingSmarty: false,
      isAddressVerified: false, // Track if address is verified
      verifiedAddressData: null, // Store verified address data

      // Error states
      state_error: false,
      country_error: false,

      // Data lists
      Countries: [],
      States: [],

      // Mode
      isEditMode: false,
    };

    this.smartyDebounceTimer = null;
    this.LoadStates = this.LoadStates.bind(this);
    this.loadCountries = this.loadCountries.bind(this);
    this.handleCheckedChange = this.handleCheckedChange.bind(this);
    this.handleManualEntryToggle = this.handleManualEntryToggle.bind(this);
    this.handleSmartySearchChange = this.handleSmartySearchChange.bind(this);
    this.searchSmartyAddress = this.searchSmartyAddress.bind(this);
    this.selectSmartyAddress = this.selectSmartyAddress.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.saveAddress = this.saveAddress.bind(this);
    this.updateAddress = this.updateAddress.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.verifyAddressWithSmarty = this.verifyAddressWithSmarty.bind(this);
  }

  componentDidMount() {
    this.LoadStates();
    this.loadCountries();
  }

  componentDidUpdate(prevProps) {
    // Handle edit mode - when addressData changes (different address selected for edit)
    if (this.props.addressData !== prevProps.addressData) {
      if (this.props.addressData && this.props.addressData.id) {
        // Edit mode with new address data
        this.setState({
          id: this.props.addressData.id,
          address1: this.props.addressData.address1 || "",
          address2: this.props.addressData.address2 || "",
          address3: this.props.addressData.address3 || "",
          city: this.props.addressData.city || "",
          state: this.props.addressData.state || "",
          zipcode: this.props.addressData.zipcode || "",
          addresstypeid: this.props.addressData.addresstypeid || 1,
          county: this.props.addressData.county || "",
          isInternational: this.props.addressData.isInternational || false,
          country: this.props.addressData.country || "",
          notes: this.props.addressData.notes || "",
          isEditMode: true,
          manualEntry: !this.props.addressData.isValidAddress,
          isAddressVerified: this.props.addressData.isValidAddress || false,
          verifiedAddressData: null,
          smartySearchQuery: this.props.addressData.isValidAddress
            ? this.props.addressData.address1
            : "",
          smartySuggestions: [],
          showSmartySuggestions: false,
        });
        if (
          (this.props.addressData.isValidAddress || false) &&
          this.props.addressData &&
          this.props.addressData.address1 &&
          this.props.addressData.isInternational == false
        ) {
          this.searchSmartyAddress(this.props.addressData.address1);
        }
      } else if (this.props.showModal && !this.props.addressData) {
        // Add mode - reset form
        this.resetForm();
      }
    }

    // Handle modal open/close
    if (this.props.showModal !== prevProps.showModal) {
      if (!this.props.showModal) {
        this.resetForm();
      }
    }
  }

  componentWillUnmount() {
    if (this.smartyDebounceTimer) {
      clearTimeout(this.smartyDebounceTimer);
    }
  }

  resetForm = () => {
    this.setState({
      id: null,
      address1: "",
      address2: "",
      address3: "",
      city: "",
      state: "",
      zipcode: "",
      addresstypeid: 1,
      county: "",
      isInternational: false,
      country: "",
      notes: "",
      validateUSPS: true,
      manualEntry: false,
      textareaActive: false,
      isLoading: false,
      smartySearchQuery: "",
      smartySuggestions: [],
      showSmartySuggestions: false,
      isLoadingSmarty: false,
      isAddressVerified: false,
      verifiedAddressData: null,
      state_error: false,
      country_error: false,
      isEditMode: false,
    });
  };

  LoadStates = async () => {
    let States = await Service.States();
    if (!_.isEmpty(States)) {
      this.setState({ States: States });
    }
  };

  loadCountries = async () => {
    let Countries = await Service.Countries();
    if (!_.isEmpty(Countries)) {
      this.setState({ Countries: Countries });
    }
  };

  handleClose = () => {
    this.resetForm();
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  showSpinner = () => {
    this.setState({ isLoading: true });
    $(".loading").show();
  };

  hideSpinner = () => {
    this.setState({ isLoading: false });
    $(".loading").hide();
  };

  handleManualEntryToggle = (e) => {
    this.setState({
      manualEntry: e.target.checked,
      smartySearchQuery: "",
      isAddressVerified: false,
      verifiedAddressData: null,
    });
  };

  // Separate handler for Smarty search input
  handleSmartySearchChange = (e, value, reason) => {
    if (reason === "reset" || reason === "clear") return;
    this.setState({ smartySearchQuery: value || "" }, () => {
      this.searchSmartyAddress(value);
    });
  };

  searchSmartyAddress = (searchText) => {
    // Clear previous timer
    if (this.smartyDebounceTimer) {
      clearTimeout(this.smartyDebounceTimer);
    }

    // Debounce for 500ms
    this.smartyDebounceTimer = setTimeout(async () => {
      if (!searchText || searchText.length < 3) {
        this.setState({ smartySuggestions: [], showSmartySuggestions: false });
        return;
      }

      this.setState({ isLoadingSmarty: true });

      try {
        // Format for Smarty API - US addresses only (non-international)
        if (!this.state.isInternational) {
          const response = await Service.SmartySuggesstions(searchText);

          if (response && response.suggestions) {
            this.setState({
              smartySuggestions: response.suggestions,
              showSmartySuggestions: true,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching Smarty suggestions:", error);
        toast.error("Error loading address suggestions");
      } finally {
        this.setState({ isLoadingSmarty: false });
      }
    }, 500);
  };

  // Format address for Smarty verification
  formatAddressForSmarty = (addressData) => {
    if (this.state.isInternational) {
      // Format for international addresses
      return {
        isInternational: true,
        street: addressData.address1 + " " + (addressData.address2 || ""),
        city: addressData.city,
        state: addressData.state,
        zipcode: addressData.zipcode,
        country: addressData.country || this.state.country,
      };
    } else {
      // Format for US addresses
      return {
        isInternational: false,
        street: addressData.address1,
        street2: addressData.address2 || "",
        city: addressData.city,
        state: addressData.state,
        zipcode: addressData.zipcode,
      };
    }
  };

  selectSmartyAddress = async (suggestion) => {
    this.showSpinner();

    try {
      // Format the selected suggestion for Smarty verification
      const formattedAddress = this.formatAddressForSmarty({
        address1: suggestion.address1,
        address2: suggestion.address2 || "",
        city: suggestion.city,
        state: suggestion.state,
        zipcode: suggestion.zipCode,
      });

      // Call Smarty verification API
      const response = await Service.SmartyValidate(formattedAddress);

      const verifiedAddress = response;
      if (!verifiedAddress) {
        this.setState({ isAddressVerified: false });
        return false;
      }

      // Safe extraction of nested properties without optional chaining
      const components = verifiedAddress.components || {};
      const analysis = verifiedAddress.analysis || {};

      // Update form with verified address data
      const addressData = {
        address1: verifiedAddress.street || suggestion.address1,
        address2: verifiedAddress.street2 || suggestion.address2 || "",
        city: verifiedAddress.city || suggestion.city,
        state: verifiedAddress.state || suggestion.state,
        zipcode: verifiedAddress.zipCode || suggestion.zipcode,
        county: verifiedAddress.county || "",
      };

      this.setState({
        ...addressData,
        smartySearchQuery: "",
        smartySuggestions: [],
        isAddressVerified: true,
        verifiedAddressData: addressData,
        manualEntry: false,
      });

      toast.success("Address verified successfully with Smarty!");
    } catch (error) {
      console.error("Smarty verification error:", error);
      toast.error(
        "Address verification failed. Please check the address or enter manually."
      );
    } finally {
      this.hideSpinner();
    }
  };

  verifyAddressWithSmarty = async () => {
    const {
      address1,
      address2,
      city,
      state,
      zipcode,
      isInternational,
      country,
    } = this.state;

    if (!address1 || !city || (!isInternational && (!state || !zipcode))) {
      toast.error(
        "Please fill in all required address fields before verification"
      );
      return false;
    }

    if (isInternational && !country) {
      toast.error("Please select a country before verification");
      return false;
    }

    this.showSpinner();

    try {
      const formattedAddress = this.formatAddressForSmarty(this.state);
      const response = await Service.SmartyValidate(formattedAddress);

      const verifiedAddress = response;

      if (!verifiedAddress) {
        this.setState({ isAddressVerified: false });
        return false;
      }

      //  Step 1: Prepare user's current input
      const userInput = {
        address1: (address1 || "").trim(),
        address2: (address2 || "").trim(),
        city: (city || "").trim(),
        state: (state || "").trim(),
        zipcode: (zipcode || "").trim(),
        country: (country || "").trim(),
      };

      //  Step 2: Get Smarty response - ALWAYS prefer Smarty data
      let addressData = {
        address1: (verifiedAddress.street || "").trim() || userInput.address1,
        address2: (verifiedAddress.street2 || "").trim() || userInput.address2,
        city: (verifiedAddress.city || "").trim() || userInput.city,
        state: (verifiedAddress.state || "").trim() || userInput.state,
        zipcode: (verifiedAddress.zipCode || "").trim() || userInput.zipcode,
        county: (verifiedAddress.county || "").trim() || "",
      };

      if (isInternational) {
        addressData.county =
          (verifiedAddress.country || "").trim() || userInput.country;
      }

      //  Step 3: Remove duplicates with priority and smarty formatting
      addressData = this.removeDuplicatesWithPriority(
        addressData,
        userInput,
        verifiedAddress
      );

      this.setState({
        ...addressData,
        isAddressVerified: true,
        verifiedAddressData: addressData,
      });

      toast.success("Address verified successfully!");
      return true;
    } catch (error) {
      console.error("Verification error:", error);
      toast.error(
        "Address verification failed. Please check the address fields."
      );
      return false;
    } finally {
      this.hideSpinner();
    }
  };

  verifyAddressWithSmarty = async () => {
    const {
      address1,
      address2,
      city,
      state,
      zipcode,
      isInternational,
      country,
    } = this.state;

    // ✅ Validation - State sirf US ke liye required
    if (!address1 || !city || (!isInternational && (!state || !zipcode))) {
      toast.error(
        "Please fill in all required address fields before verification"
      );
      return false;
    }

    if (isInternational && !country) {
      toast.error("Please select a country before verification");
      return false;
    }

    this.showSpinner();

    try {
      const formattedAddress = this.formatAddressForSmarty(this.state);
      const response = await Service.SmartyValidate(formattedAddress);

      let verifiedAddress = response;

      if (!verifiedAddress) {
        this.setState({ isAddressVerified: false });
        return false;
      }

      // Step 1: Prepare user's current input
      let userInput = {
        address1: (address1 || "").trim(),
        address2: (address2 || "").trim(),
        city: (city || "").trim(),
        state: (state || "").trim(),
        zipcode: (zipcode || "").trim(),
        country: (country || "").trim(),
      };

      // Step 2: Get Smarty response
      let addressData = {
        address1: (verifiedAddress.street || "").trim() || userInput.address1,
        address2: (verifiedAddress.street2 || "").trim() || userInput.address2,
        city: (verifiedAddress.city || "").trim() || userInput.city,
        state: (verifiedAddress.state || "").trim() || userInput.state,
        zipcode: (verifiedAddress.zipCode || "").trim() || userInput.zipcode,
        county: (verifiedAddress.county || "").trim() || "",
      };

      if (isInternational) {
        addressData.county =
          (verifiedAddress.country || "").trim() || userInput.country;
      }

      // Step 3: Remove duplicates with international support
      addressData = this.removeDuplicatesWithPriority(
        addressData,
        userInput,
        verifiedAddress,
        isInternational
      );

      console.log("Final Address Data:", addressData);

      this.setState({
        ...addressData,
        isAddressVerified: true,
        verifiedAddressData: addressData,
      });

      toast.success("Address verified successfully!");
      return true;
    } catch (error) {
      console.error("Verification error:", error);
      toast.error(
        "Address verification failed. Please check the address fields."
      );
      return false;
    } finally {
      this.hideSpinner();
    }
  };

  //  Main duplicate removal with priority and international support
  removeDuplicatesWithPriority = (
    smartyData,
    userInput,
    verifiedAddress,
    isInternational
  ) => {
    const cleanedData = { ...smartyData };

    // Define field priorities based on address type
    const fieldPriority = {
      address1: 5, // ALWAYS Required - HIGHEST
      city: 4, // ALWAYS Required
      country: 4, // ALWAYS Required for international
      address2: 1, // Optional - LOWEST
    };

    // State aur zipcode ka priority depends on address type
    if (isInternational) {
      fieldPriority.state = 0; // NOT REQUIRED - Lowest priority
      fieldPriority.zipcode = 0; // NOT REQUIRED - Lowest priority
    } else {
      fieldPriority.state = 3; // Required for US
      fieldPriority.zipcode = 3; // Required for US
    }

    // Define required fields based on address type
    const requiredFields = isInternational
      ? ["address1", "city", "country"] // International mein state required nahi
      : ["address1", "city", "state", "zipcode"]; // US mein state required

    const fields = isInternational
      ? ["address1", "address2", "city", "state", "zipcode", "country"]
      : ["address1", "address2", "city", "state", "zipcode"];

    console.log("Address Type:", isInternational ? "International" : "US");
    console.log("Required Fields:", requiredFields);
    console.log("Field Priorities:", fieldPriority);

    // Step 1: Count occurrences in Smarty response
    const valueOccurrences = {};

    fields.forEach((field) => {
      const value = (smartyData[field] || "").trim();
      if (value) {
        const lowerValue = value.toLowerCase(); // ✅ Lowercase key
        if (!valueOccurrences[lowerValue]) {
          valueOccurrences[lowerValue] = [];
        }
        valueOccurrences[lowerValue].push({
          field: field,
          value: value, // Original value (with case)
          lowerValue: lowerValue,
          priority: fieldPriority[field] || 0,
        });
      }
    });

    // Step 2: Find duplicates
    Object.keys(valueOccurrences).forEach((lowerValue) => {
      const occurrences = valueOccurrences[lowerValue];

      // Only process if value appears in multiple fields
      if (occurrences.length <= 1) return;

      let keepField = null;

      // Step 3: Check if value exists in required fields
      const requiredOccurrences = occurrences.filter((occ) =>
        requiredFields.includes(occ.field)
      );

      if (requiredOccurrences.length > 0) {
        // Value is in required fields - keep the highest priority one
        keepField = requiredOccurrences.sort(
          (a, b) => b.priority - a.priority
        )[0];
      } else {
        // Value is NOT in required fields (only in address2)
        // Check user input - which field did user enter this value in?
        let userField = null;
        fields.forEach((field) => {
          // ✅ Lowercase comparison
          const userValue = (userInput[field] || "").trim().toLowerCase();
          if (userValue === lowerValue) {
            userField = field;
          }
        });

        if (userField) {
          // User entered this value in a specific field - preserve it
          keepField =
            occurrences.find((occ) => occ.field === userField) ||
            occurrences[0];
        } else {
          // User didn't enter this value - keep first occurrence
          keepField = occurrences[0];
        }
      }

      // Step 4: Remove duplicates - keep only in keepField
      occurrences.forEach((occ) => {
        if (occ.field !== keepField.field) {
          cleanedData[occ.field] = "";
        }
      });
    });

    return cleanedData;
  };

  changeHandler = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
      isAddressVerified: false, // Reset verification status when fields change
      verifiedAddressData: null,
    });

    if (this.state[name + "_error"]) {
      this.setState({ [name + "_error"]: false });
    }
  };

  handleSelectChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,

      verifiedAddressData: null,
    });
  };

  handleCheckedChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.checked,
        isAddressVerified: false,
        verifiedAddressData: null,
      },
      () => {
        if (!this.state.isInternational) {
          this.setState({
            country: "",
          });
        }
      }
    );
  };

  countryDropdown = () => {
    let { Countries, country, country_error } = this.state;
    return (
      <div className="col-sm-6">
        <Autocomplete
          options={!_.isEmpty(Countries) ? Countries : []}
          autoComplete={true}
          autoHighlight={true}
          selectOnFocus
          clearOnBlur
          onChange={this.changeHandlerCountry}
          getOptionLabel={(option) => {
            if (option && option.inputValue) return option.inputValue;
            if (option !== undefined) return option;
            return "";
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            if (
              params.inputValue !== "" &&
              (_.isEmpty(filtered) ||
                filtered.findIndex(
                  (x) => x.toUpperCase() === params.inputValue.toUpperCase()
                ) === -1)
            ) {
              filtered.push({
                name: `Add "${params.inputValue}"`,
                inputValue: params.inputValue,
              });
            }
            return filtered;
          }}
          value={country}
          id="country"
          renderOption={(option) => {
            if (option && option.name) return option.name;
            if (option !== undefined) return option;
            return "";
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Country"
              variant="standard"
              error={country_error}
              helperText={country_error ? "Country is required" : ""}
              required
              label="Country"
              className="md-form state-container border-bottom-0 w-100"
              fullWidth
              inputProps={{
                ...params.inputProps,
                id: "country",
                name: "country",
                className: "form-control",
                autoComplete: "disabled",
              }}
            />
          )}
        />
      </div>
    );
  };

  changeHandlerState = (e, value) => {
    let valueV = "";
    if (value && value.inputValue) {
      valueV = value.inputValue;
    } else {
      valueV = value;
    }

    this.setState({
      state: valueV,
      state_error: !valueV || valueV === "",
      isAddressVerified: false,
      verifiedAddressData: null,
    });
  };

  changeHandlerCountry = (e, value) => {
    let valueV = "";
    if (value && value.inputValue) {
      valueV = value.inputValue;
    } else {
      valueV = value;
    }

    this.setState({
      country: valueV,
      country_error: !valueV || valueV === "",
      isAddressVerified: false,
      verifiedAddressData: null,
    });
  };

  handleFormSubmit = async (e) => {
    e.preventDefault();

    if (e.target) {
      e.target.className += " was-validated";
    }

    let v = false;
    try {
      v = e.target.checkValidity();
    } catch (ex) {
      if (e.target.id) {
        v = document.getElementById(e.target.id).checkValidity();
      }
    }

    // Validate state
    if (
      !this.state.isInternational &&
      (this.state.state == null ||
        this.state.state == "" ||
        this.state.state == undefined)
    ) {
      await this.setState({ state_error: true });
    } else {
      await this.setState({ state_error: false });
    }

    // Validate country for international addresses
    if (
      this.state.isInternational &&
      (!this.state.country || this.state.country === "")
    ) {
      await this.setState({ country_error: true });
    } else {
      await this.setState({ country_error: false });
    }

    if (
      !v ||
      this.state.state_error === true ||
      (this.state.isInternational && this.state.country_error)
    ) {
      toast.error("Please fill in all required fields");
      return false;
    }

    // For US Address with Manual Entry OFF: Must be verified
    if (
      !this.state.isInternational &&
      !this.state.manualEntry &&
      !this.state.isAddressVerified
    ) {
      toast.error(
        "Please select and verify an address from Smarty suggestions"
      );
      return false;
    }

    // For International with Manual Entry OFF: Must be verified
    if (
      this.state.isInternational &&
      !this.state.manualEntry &&
      !this.state.isAddressVerified
    ) {
      toast.error("Please verify the address before saving");
      return false;
    }

    // Use verified address data if available, otherwise use current state
    const addressToSave =
      this.state.isAddressVerified && this.state.verifiedAddressData
        ? this.state.verifiedAddressData
        : this.state;

    const body = {
      address1: addressToSave.address1,
      address2: addressToSave.address2,
      address3: this.state.address3,
      city: addressToSave.city,
      state: addressToSave.state,
      zipcode: addressToSave.zipcode,
      addresstypeid: this.state.addresstypeid,
      county: addressToSave.county || this.state.county,
      isInternational: this.state.isInternational,
      country: this.state.country,
      notes: this.state.notes,
      isValidAddress: this.state.isAddressVerified,
      id: 0,
      smartyMetadata: this.state.smartyMetadata,
    };

    if (this.state.isEditMode && this.state.id) {
      const data = { User_Id: 0, Addresses: [] };
      body.id = this.state.id;
      data.Addresses.push(body);
      data.User_Id = this.props.memberid;

      await this.updateAddress(data);
    } else {
      await this.saveAddress(body);
    }
  };

  saveAddress = async (body) => {
    const totalDisabled = $(
      ".addressMemberForm input:disabled,.addressMemberForm select:disabled"
    );
    const totalDisabledCount = totalDisabled ? totalDisabled.length : 0;

    if (totalDisabledCount === 6) {
      return false;
    }

    const Url = "/api/Member/CreateAddress?memberid=" + this.props.memberid;
    this.showSpinner();

    try {
      const { data } = await axios.post(Url, body);
      this.hideSpinner();

      if (data.status) {
        if (data.status.toLowerCase() === "success") {
          toast.success(data.message);
          this.props.refreshData(this.props.memberid);
          this.handleClose();
        } else {
          toast.error(data.message);
        }
      } else {
        toast.error("Could not complete the operation.");
      }
    } catch (error) {
      this.hideSpinner();
      toast.error("An error occurred while saving the address.");
      console.error("Save address error:", error);
    }
  };

  updateAddress = async (body) => {
    const Url = "/api/Member/UpdateMemberAddresses";
    this.showSpinner();

    try {
      const { data } = await axios.post(Url, body);
      this.hideSpinner();

      if (data.status) {
        if (data.status.toLowerCase() === "success") {
          toast.success(data.message);

          this.props.refreshData(this.props.memberid);
          this.handleClose();
        } else {
          toast.error(data.message);
        }
      } else {
        toast.error("Could not complete the operation.");
      }
    } catch (error) {
      this.hideSpinner();
      toast.error("An error occurred while updating the address.");
      console.error("Update address error:", error);
    }
  };

  renderButtons = () => {
    const {
      isInternational,
      manualEntry,
      isAddressVerified,
      isLoading,
      isEditMode,
      address1,
      city,
      state,
      zipcode,
    } = this.state;
    const allowManualVerification =
      address1 &&
      city &&
      state &&
      zipcode &&
      !isInternational &&
      !manualEntry &&
      !isAddressVerified;
    // US Address with Manual Entry OFF
    if (!isInternational && !manualEntry) {
      return (
        <div className="col-12 text-center d-flex justify-content-center mt-4">
          <button
            className="btn btn-outline-danger btn-sm px-4"
            type="button"
            onClick={this.handleClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          {allowManualVerification ? (
            <button
              className="btn btn-info btn-sm px-4 ml-2"
              type="button"
              onClick={this.verifyAddressWithSmarty}
              disabled={isLoading}
            >
              {isLoading ? "Verifying..." : "Verify Address"}
            </button>
          ) : (
            <button
              className="btn btn-primary btn-sm px-4 ml-2"
              type="submit"
              disabled={isLoading || !isAddressVerified}
            >
              {isLoading ? (
                <>Processing...</>
              ) : isEditMode ? (
                "Update Address"
              ) : (
                "Save Address"
              )}
            </button>
          )}
        </div>
      );
    }

    // International Address with Manual Entry OFF
    if (isInternational && !manualEntry) {
      return (
        <div className="col-12 text-center d-flex justify-content-center mt-4">
          <button
            className="btn btn-outline-danger btn-sm px-4"
            type="button"
            onClick={this.handleClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          {!isAddressVerified ? (
            <button
              className="btn btn-info btn-sm px-4 ml-2"
              type="button"
              onClick={this.verifyAddressWithSmarty}
              disabled={isLoading}
            >
              {isLoading ? "Verifying..." : "Verify Address"}
            </button>
          ) : (
            <button
              className="btn btn-primary btn-sm px-4 ml-2"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <>Processing...</>
              ) : isEditMode ? (
                "Update Address"
              ) : (
                "Save Address"
              )}
            </button>
          )}
        </div>
      );
    }

    // Manual Entry ON (both US and International)
    if (manualEntry) {
      return (
        <div className="col-12 text-center d-flex justify-content-center mt-4">
          <button
            className="btn btn-outline-danger btn-sm px-4"
            type="button"
            onClick={this.handleClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary btn-sm px-4 ml-2"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? (
              <>Processing...</>
            ) : isEditMode ? (
              "Update Address"
            ) : (
              "Save Address"
            )}
          </button>
          {!isAddressVerified && (
            <button
              className="btn btn-secondary btn-sm px-4 ml-2"
              type="button"
              onClick={this.verifyAddressWithSmarty}
              disabled={isLoading}
            >
              {isLoading ? "Verifying..." : "Verify Address (Optional)"}
            </button>
          )}
        </div>
      );
    }

    return null;
  };

  render() {
    const { addressTypes, showModal, memberid } = this.props;
    const {
      isInternational,
      manualEntry,
      isLoading,
      state_error,
      States,
      addresstypeid,
      address1,
      address2,
      city,
      state,
      zipcode,
      notes,
      textareaActive,
      isEditMode,
      smartySearchQuery,
      smartySuggestions,
      isLoadingSmarty,
      isAddressVerified,
    } = this.state;

    const hasPermission =
      AuthService.canOwnAdd(PermissionFeature.ContactAddresses, memberid) ||
      AuthService.canMemberAdd(PermissionFeature.ContactAddresses);
    const hasUpdatePermission =
      AuthService.canOwnUpdate(PermissionFeature.ContactAddresses, memberid) ||
      AuthService.canMemberUpdate(PermissionFeature.ContactAddresses);
    const canEdit = isEditMode ? hasUpdatePermission : hasPermission;

    // Determine if address fields should be disabled
    const isAddressDisabled =
      !isInternational && !manualEntry && isAddressVerified;
    const showSmartySearch = !isInternational && !manualEntry;

    return (
      <Modal
        className="AddressModal latest"
        show={showModal}
        onHide={this.handleClose}
        centered
        size="lg"
      >
        <Modal.Header className="modal-header bg-secondary py-2" closeButton>
          <Modal.Title>
            <h5 className="modal-title text-uppercase text-white mt-0">
              {isEditMode ? "EDIT ADDRESS" : "ADD ADDRESS"}
            </h5>
          </Modal.Title>
        </Modal.Header>
        {canEdit ? (
          <Modal.Body>
            <form
              id="addressForm"
              className="form-horizontal addressMemberForm"
              onSubmit={this.handleFormSubmit}
              noValidate
            >
              <div className="row">
                <div className="col-12">
                  <div data-repeater-item className="row mb-4">
                    <div className="col-sm-4 align-self-center">
                      <select
                        className="browser-default custom-select"
                        onChange={this.handleSelectChange}
                        id="addresstypeid"
                        name="addresstypeid"
                        value={addresstypeid}
                        required
                      >
                        {addressTypes.map((item, idx) => (
                          <option key={idx} value={item.id}>
                            {item.code}
                          </option>
                        ))}
                      </select>
                      <div className="invalid-feedback">
                        Address Type is required.
                      </div>
                    </div>

                    {/* Checkboxes with Bootstrap 5 styling */}
                    <div className="col-md-8 my-md-0 my-3">
                      <div className="d-flex gap-3 align-items-center">
                        <div className="custom-checkbox ml-2 pl-1">
                          <input
                            id="isInternational"
                            name="isInternational"
                            type="checkbox"
                            checked={isInternational}
                            onChange={this.handleCheckedChange}
                            className="custom-control-input pr-2"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="isInternational"
                            style={{ paddingTop: 2 }}
                          >
                            International Address
                          </label>
                        </div>
                        <div className="custom-checkbox ml-2 pl-3">
                          <input
                            id="manualEntry"
                            name="manualEntry"
                            type="checkbox"
                            checked={manualEntry}
                            onChange={this.handleManualEntryToggle}
                            className="custom-control-input pr-2"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="manualEntry"
                            style={{ paddingTop: 2 }}
                          >
                            Manual Entry
                          </label>
                        </div>
                      </div>
                      {!isInternational &&
                        !manualEntry &&
                        !isAddressVerified && (
                          <small className="text-muted d-block mt-1">
                            Search and select an address from Smarty suggestions
                            for verification
                          </small>
                        )}
                      {!isInternational && manualEntry && (
                        <small className="text-muted d-block mt-1">
                          Enter address manually. Optionally verify with Smarty
                          before saving.
                        </small>
                      )}
                      {isInternational &&
                        !manualEntry &&
                        !isAddressVerified && (
                          <small className="text-muted d-block mt-1">
                            Enter international address and click Verify Address
                          </small>
                        )}
                      {isInternational && manualEntry && (
                        <small className="text-muted d-block mt-1">
                          Enter international address manually. Optionally
                          verify before saving.
                        </small>
                      )}
                    </div>

                    <div className="clearfix"></div>

                    {/* Smarty Search Field - Using Material-UI Autocomplete */}
                    {showSmartySearch && (
                      <div className="col-sm-12 mb-3">
                        <Autocomplete
                          id="smartySearch"
                          options={smartySuggestions}
                          getOptionLabel={(option) => option.address1 || ""}
                          loading={isLoadingSmarty}
                          value={null}
                          inputValue={smartySearchQuery}
                          onInputChange={this.handleSmartySearchChange}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              this.selectSmartyAddress(newValue);
                            }
                          }}
                          renderOption={(option) => (
                            <div>
                              <strong>{option.address1}</strong>
                              <br />
                              <small className="text-muted">
                                {option.city}, {option.state} {option.zipcode}
                              </small>
                            </div>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Search Address (Smarty Validation)"
                              placeholder="Start typing street address, city, or ZIP code..."
                              variant="standard"
                              fullWidth
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {isLoadingSmarty && (
                                      <div
                                        className="spinner-border spinner-border-sm text-primary"
                                        role="status"
                                      ></div>
                                    )}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                        <small className="text-muted d-block mt-1">
                          Enter street address, city, or ZIP code to search with
                          Smarty
                        </small>
                      </div>
                    )}

                    {/*isInternational && !manualEntry && !isAddressVerified && this.countryDropdown()*/}

                    {/* Show verified address info */}
                    {isAddressVerified && (
                      <div className="col-sm-12 mb-3">
                        <div className="alert alert-success" role="alert">
                          <i className="fas fa-check-circle mr-1"></i>
                          <span className="small">
                            <strong>Address Verified!</strong> This address has
                            been verified with Smarty
                          </span>
                          <button
                            type="button"
                            className="close"
                            onClick={() =>
                              this.setState({
                                verifiedAddressData: null,
                                smartySearchQuery: "",
                              })
                            }
                          >
                            <span>&times;</span>
                          </button>
                        </div>
                      </div>
                    )}

                    {/* Address Fields */}
                    <div className="col-sm-12 mb-2">
                      <MDBInput
                        id="address1"
                        name="address1"
                        containerClass="mb-0"
                        value={address1}
                        onChange={this.changeHandler}
                        label="Address Line 1"
                        required
                        type="text"
                        disabled={isAddressDisabled}
                      >
                        <div className="invalid-feedback">
                          Address 1 is required.
                        </div>
                      </MDBInput>
                    </div>

                    <div className="col-sm-12 mb-2">
                      <MDBInput
                        id="address2"
                        name="address2"
                        containerClass="mb-0"
                        value={address2}
                        onChange={this.changeHandler}
                        label="Address Line 2 (Optional)"
                        type="text"
                        disabled={isAddressDisabled}
                      />
                    </div>

                    <div className="col-sm-4 mb-2">
                      <MDBInput
                        id="city"
                        name="city"
                        containerClass="mb-0"
                        value={city}
                        onChange={this.changeHandler}
                        label="City"
                        required
                        type="text"
                        disabled={isAddressDisabled}
                      >
                        <div className="invalid-feedback">
                          City is required.
                        </div>
                      </MDBInput>
                    </div>

                    {isInternational ? (
                      <div className="col-sm-4 mb-2">
                        <MDBInput
                          id="state-international"
                          name="state"
                          containerClass="mb-0"
                          value={state}
                          onChange={this.changeHandler}
                          label="State/Province"
                          type="text"
                          disabled={isAddressDisabled}
                        ></MDBInput>
                      </div>
                    ) : (
                      <div className="col-sm-4 mb-2">
                        <Autocomplete
                          options={!_.isEmpty(States) ? States : []}
                          autoComplete={true}
                          autoHighlight={true}
                          selectOnFocus
                          clearOnBlur
                          onChange={this.changeHandlerState}
                          getOptionLabel={(option) => {
                            if (option && option.inputValue)
                              return option.inputValue;
                            if (option !== undefined) return option;
                            return "";
                          }}
                          filterOptions={(options, params) => {
                            const filtered = filter(options, params);
                            if (
                              params.inputValue !== "" &&
                              (_.isEmpty(filtered) ||
                                filtered.findIndex(
                                  (x) =>
                                    x.toUpperCase() ===
                                    params.inputValue.toUpperCase()
                                ) === -1)
                            ) {
                              filtered.push({
                                state: `Add "${params.inputValue}"`,
                                inputValue: params.inputValue,
                              });
                            }
                            return filtered;
                          }}
                          value={state}
                          id="state"
                          renderOption={(option) => {
                            if (option && option.state) return option.state;
                            if (option !== undefined) return option;
                            return "";
                          }}
                          disabled={isAddressDisabled}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select or enter state"
                              variant="standard"
                              error={state_error}
                              helperText={
                                state_error ? "State is required" : ""
                              }
                              required
                              label="State"
                              className="md-form state-container w-100"
                              fullWidth
                              inputProps={{
                                ...params.inputProps,
                                id: "state",
                                name: "state",
                                className: "form-control",
                                autoComplete: "disabled",
                              }}
                            />
                          )}
                        />
                      </div>
                    )}

                    <div className="col-sm-4 mb-2">
                      <MDBInput
                        id="zipcode"
                        name="zipcode"
                        containerClass="mb-0"
                        value={zipcode}
                        onChange={this.changeHandler}
                        label={isInternational ? "Postal Code" : "ZIP Code"}
                        required={!isInternational}
                        type="text"
                        disabled={isAddressDisabled}
                      >
                        {!isInternational && (
                          <div className="invalid-feedback">
                            "ZIP Code is required.
                          </div>
                        )}
                      </MDBInput>
                    </div>

                    {/* Country field - only for international addresses with manual entry or not verified */}
                    {isInternational && this.countryDropdown()}

                    {/* Notes field for all addresses */}
                    {isInternational && (
                      <div className="col-12 mt-4">
                        <div className="form-floating">
                          <textarea
                            className="form-control"
                            name="notes"
                            id="notes"
                            value={notes}
                            rows="3"
                            style={{ height: "auto" }}
                            onFocus={() =>
                              this.setState({ textareaActive: true })
                            }
                            onBlur={(e) => {
                              if (!e.target.value) {
                                this.setState({ textareaActive: false });
                              }
                            }}
                            onChange={this.changeHandler}
                            placeholder="Additional Notes"
                            disabled={isAddressDisabled}
                          />
                          <label htmlFor="notes">
                            Additional Notes (Optional)
                          </label>
                        </div>
                      </div>
                    )}
                  </div>

                  {this.renderButtons()}
                </div>
              </div>
            </form>
          </Modal.Body>
        ) : (
          <Modal.Body>
            <p className="text-center text-muted">Not enough permissions!</p>
          </Modal.Body>
        )}
      </Modal>
    );
  }
}

export default AddressModal;
